<template>
  <div>
    <hr />
    <b-row class="ml-1 mr-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
      <div class="ml-auto">
          <label class="mr-1 h7 my-auto"> {{ $t("members-table.extract") }} </label>
          <b-button class="esep-blue-bg float-right" @click.prevent="downloadItem">
            Excel
          </b-button>
        </div>
    </b-row>
    <b-table
      id="reports-table"
      class="mt-2"
      striped
      hover
      borderless
      :items="reportsList"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
      tbody-class="bg-white"
    >

      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="showCensus(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('census.show')"
        >
          <b-icon icon="eye"></b-icon>
        </b-button>
      </template>

      <template v-slot:cell(actionTrainer)="row">
        <b-button
          size="sm"
          @click="showTrainer(row.item)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('census.show')"
        >
          <b-icon icon="eye"></b-icon>
        </b-button>

        <b-button
          size="sm"
          @click="getLeadersLogbook(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('reports.getLogbook')"
        >
          <b-icon icon="file-earmark-arrow-down" ></b-icon>
        </b-button>
      </template>

      <template v-if="canSeeLogbook" v-slot:cell(actionMember)="row">
        <b-button
            size="sm"
            @click="getMembersLogbook(row)"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('reports.getLogbook')"
        >
          <b-icon icon="file-earmark-arrow-down" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t('reports.emptyTable') }}</h6>
      </template>

    </b-table>
    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="members-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {prettifyMoney, prettifyDate, prettifyDateTime} from '../../services/utils';
import routes  from "../../services/routing.service";
import memberService from '../../services/member.service';
import { handleApiError } from "../../services/error.service";

export default {
  computed: {
    rows() {
      return this.reportsList.length;
    },
  },
  mounted() {
    memberService.getUserInfo(this.$store.state.auth.username).then(
        (response) => {
          let userInfo = response.data;
          this.hasLogbookPermission(userInfo);
        }
    )
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      canSeeLogbook: false,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "Όλα",
        },
      ],
      routes: routes.routes,
    }
  },
  props: {
    fields: {
      type: Array
    },
    reportsList: {
      type: Array
    },
    usersAccessibleUnits: {
      type: Array
    },
    sortBy: {
      type: String
    },
    sortDesc: {
      type: Boolean
    }   
  }, 
  methods: {
    downloadItem() {
      this.$emit('download-report');
    },
    formatEmptyField(item) {
      let value = item
      if(item == null || item == "") {
        value = "-"
      }
      return value
    },
    prettifyMoney (amount) {
      return prettifyMoney(amount);
    },
    prettifyDate(stringDate) {
      return prettifyDate(stringDate);
    },
    prettifyDateTime(stringDate) {
      return prettifyDateTime(stringDate);
    },
    prettifyMemberName(member){
      if (member) {
        return `${member.firstName} ${member.surName}`
      }
      return "-"
    },
    translateType(type) {
      return this.$t('memberTypeEnums.'+ type);
    },
    translateExcursionBranch(branch) {
      return this.$t('ExcursionBranchEnums.'+ branch);
    },
    translateExcursionType(type) {
      return this.$t('excursionTypeEnums.'+ type);
    },

    translateExcursionStatus(type) {
      return this.$t('excursionStatusEnums.'+ type);
    },
    translateStatus(status) {
      return this.$t('memberStatusEnums.'+ status);
    },
    translateSex(sex) {
      return this.$t('memberSexEnums.'+ sex);
    },
    translateTitle(title) {
      return this.$t('licensesEnums.'+title);
    },
    translateLicenseType(type) {
      return this.$t('member-licenses.'+ type);
    },
    translateLeaderLicenseStatus(status) {
      return this.$t('licenseStatusEnums.'+ status);
    },
    translateApplyActivityStatus(status) {
      return this.$t('applyActivityStatusEnums.'+ status);
    },
    translateHonourType(type){
      return this.$t('honourEnums.'+ type);
    },
    translateReplacement(idReplacement) {
      if(idReplacement == true) {
        return 'ΝΑΙ';
      } else {
        return 'ΟΧΙ';
      }
    },
    translateRole(type) {
      return this.$t('roleEnums.'+type);
    },
    translateGroupType(type) {
      return this.$t('unitTypesEnums.'+type)
    },
    translateGroupStatus(status) {
      return this.$t('unitStatusEnums.'+ status);
    },
    translateCensusStatus(status) {
      return this.$t('censusStatusEnums.'+ status);
    },
    translateSupportType(type) {
      return this.$t('supportEnums.'+type);
    },
    translateSupportStatus(type) {
      return this.$t('supportStatusEnums.'+type);
    },
    transleOldHqTitle(title) {
      return this.$t('oldHqEnums.'+title);
    },
    translateLicensePropType(type) {
      return this.$t('member-licenses.'+type);
    },
    translateManualCheck(manualCheck) {
      let text;
      if(manualCheck) {
        text = this.$t('common.yes')
      } else {
        text = this.$t('common.no')
      }
      return text;
    },
    translateBranch(branch) {
      return this.$t('branchTypeEnums.'+ branch);
    },
    translateTrainingStatus(status) {
      return this.$t('trainingStatusEnums.'+ status);
    },
    translateParticipationStatus(status) {
      return this.$t('participationStatusEnums.'+ status);
    },
    translatePaymentType(type) {
      return this.$t('paymentTypeEnums.'+ type);
    },
    translateDiplomaStatus(status) {
      return this.$t('studyStatusEnums.'+ status);
    },
    translateLicenseStatus(status) {
      return this.$t('trainingLicenseStatusEnums.'+ status);
    },
    translateTrainingLicenseType(status) {
      return this.$t('trainingLicenseTypesEnums.'+ status);
    },
    translateConferenceMemberType(status) {
      return this.$t('conferenceEnums.'+ status);
    },
    showCensus(census) {
      this.$emit('show-census', census.item);
    },
    showTrainer(trainer) {
      this.$log.debug(trainer)
      window.open(this.routes.leader.edit + `/${trainer.id}`, '_blank');
    },
    getLeadersLogbook(row) {
      this.downloading = true;
      const fileDownload = require('js-file-download');
      console.error(row.item.memberId);
      memberService.downloadLeadersLogbook(row.item.memberId).then(
        (response) => { 
          fileDownload(response.data, `${row.item.memberId}-logbook.pdf`);
          this.downloading = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.downloading = false;
          this.$emit('error:api', errorMessage);
        }
      )
    },
    hasLogbookPermission(userInfo) {
      for(var i=0; i< userInfo.roles.length; i++){
        if(userInfo.roles[i].name === "ADMIN" || userInfo.roles[i].name === "TRAIN_ADMIN") {
          this.canSeeLogbook= true;
        }
      }
    },
    getMembersLogbook(row) {
      this.downloading = true;
      const fileDownload = require('js-file-download');
      console.error(row.item.id);
      memberService.downloadLeadersLogbook(row.item.id).then(
          (response) => {
            fileDownload(response.data, `${row.item.id}-logbook.pdf`);
            this.downloading = false;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.downloading = false;
            this.$emit('error:api', errorMessage);
          }
      )
    },
  }
}
</script>